import React from 'react'

import { Link } from 'react-router-dom'
import { Table, Switch } from 'antd'

import { LAYOUT_ADMIN_TEMPLATE_EDIT } from '../../navigation'

const rowKey = (row) => row.id.toString()

const Widget = (props) => {
  const { onChangeStatus, isSecondaryLoading } = props
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name, record) => <Link to={LAYOUT_ADMIN_TEMPLATE_EDIT(record.id)}>{name}</Link>
    },
    { title: 'Description', dataIndex: 'description', key: 'description', ellipsis: true },
    { title: 'Type', dataIndex: 'type', key: 'type', width: 120 },
    {
      title: 'Status',
      dataIndex: 'active',
      key: 'active',
      width: 140,
      render: (active, record) => {
        const onChange = (st) => onChangeStatus(record.id, st)
        return (
          <>
            <Switch
              checkedChildren='Enabled'
              unCheckedChildren='Disabled'
              onClick={onChange}
              defaultChecked={active}
              loading={isSecondaryLoading}
            />
          </>
        )
      }
    }
  ]

  return (
    <>
      <Table
        columns={columns}
        dataSource={props.list}
        size='small'
        pagination={false}
        rowKey={rowKey}
        bordered
      />
    </>
  )
}

export default Widget
